import { Component, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, debounceTime, switchMap, startWith, distinctUntilChanged } from 'rxjs/operators';
import { Observable, Subscription, Subject, throwError, interval } from 'rxjs';
import Swal from 'sweetalert2';

import { environment } from '@teem/environments/environment';
import { parseDate, queryString } from '@teem/helpers/functions';
import { messages as i18n } from '@teem/constants/messages';
import { order as OrderApi } from '@teem/core/constants/api';

import { OrderService } from '@teem/core/services/order.service';
import { LoaderService } from '@teem/core/services/loader.service';

import { ACTIONS as ORDER_ACTIONS } from '@teem/constants/order';

declare var $;

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  isSearch: boolean = false;
  searchText: string;
  search: Subject<string> = new Subject<string>();
  searchSubscription: Subscription;
  orders: Array<any> = [];
  scheduleOrders: any;
  remindOrders: any;
  stats: any = {
    all_orders_count: 0,
    pickup_orders_count: 0,
    delivery_orders_count: 0
  };
  paginator: any = {
    id: 'orders-table-paginator',
    currentPage: 1,
    itemsPerPage: environment.pageSize,
    totalItems: 0
  }
  loading: boolean = false;
  fromDate: any = '';
  toDate: any = '';
  fromDueDate: any = '';
  toDueDate: any = '';
  minAmount: any = '';
  maxAmount: any = '';
  userInfo: any;
  selectedOrderType: string = 'all';
  selectedOrder: any = null;
  order_status: any = '';
  params: any = {};
  orderStatues: any = [{ 'id': 'preparing', 'name': 'Preparing' }, { 'id': 'complete', 'name': 'Complete' }];

  // sorting
  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';

  sortData(column: string) {
    alert()
    // If no sorting was applied or a different column is clicked, sort in 'asc'
    if (this.sortColumn !== column) {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    } else {
      // If the same column is clicked, toggle the sort direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    }
    this.params.order_by = this.sortColumn;
    this.params.direction = this.sortDirection;
    this.getPage(1, true, this.params)
  }


  constructor(
    private loaderService: LoaderService,
    private orderService: OrderService,
    private elem: ElementRef,
    private httpClient: HttpClient
  ) { }

  ngOnInit(): void {
    this.searchSubscription = this.search.asObservable().pipe(debounceTime(300)).subscribe(data => {
      if (this.searchText != data) {
        this.searchText = data;

        if (this.searchText.length == 0 || this.searchText.length >= 3) {
          this.getPage(1, false);
        }
      }
    })

    this.getPage(1);
    this.fetchStats();
    this.fetchScheduleOrders()
  }

  fetchStats() {
    this.orderService.stats().subscribe((data: any) => {
      // this.stats.all_orders_count = data.all_orders_count
      this.stats.all_orders_count = data['all_order_count'];
      this.stats.pickup_orders_count = data['pickup_count'];
      this.stats.delivery_orders_count = data['delivery_count'];

      setTimeout(() => {
        $('#tab-links-select[nice-select]').niceSelect('update');
      }, 10);
    });
  }

  fetchScheduleOrders() {
    interval(200000) // Poll every 5 seconds
      .pipe(startWith(0), switchMap(() => this.orderService.scheduleOrder()))
      .subscribe((data: any) => {
        this.scheduleOrders = data?.schedule_orders;
        this.remindOrders = data?.remind_orders;
      }
    );
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe()
  }

  searchOrders(term: string) {
    this.search.next(term);
  }

  toggleFilters() {
    $('.filters_expanded').toggleClass('visible');
    this.resetStatusFilters();
    this.resetDateFilters();
    this.resetAmountFilters();
    this.order_status = '';
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  clearAllFilter() {
    this.params = {};
    this.order_status = '';
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetStatusFilters();
    this.searchOrders("");
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  onChangePerPageItems(page: any) {
    if (page?.limit) {
      this.paginator.itemsPerPage = page?.limit;
      this.params.limit = page?.limit;
      this.getPage(1, false, this.params);
    }
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;
    if (this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.searchOrders("");
    }
  }

  filterByDate() {

    if (this.fromDate) {
      this.params.from_date = this.fromDate;
    }
    if (this.toDate) {
      this.params.to_date = this.toDate;
    }

    this.getPage(1, true, this.params);
  }

  filterByDueDate() {

    if (this.fromDueDate) {
      this.params.from_due_date = this.fromDueDate;
    }
    if (this.toDueDate) {
      this.params.to_due_date = this.toDueDate;
    }

    this.getPage(1, true, this.params);
  }

  filterByStatus() {
    this.params.order_status = "";
    if(this.order_status) {
      this.params.order_status = this.order_status;
    }

    this.getPage(1, true, this.params);
  }

  filterByAmount() {
    if(this.minAmount) {
      this.params.min_amount = this.minAmount;
    }else{
      this.params.min_amount = '';
    }
    if(this.maxAmount) {
      this.params.max_amount = this.maxAmount;
    }else{
      this.params.max_amount = '';
    }

    this.getPage(1, true, this.params);
  }

  resetDateFilters() {
    if (this.fromDate || this.toDate) {
      this.fromDate = "";
      this.toDate = "";
      this.filterByDate();
    }

    if (this.fromDueDate || this.toDueDate) {
      this.fromDueDate = "";
      this.toDueDate = "";
      this.filterByDate();
    }
  }

  resetAmountFilters() {
    if(this.minAmount || this.maxAmount) {
      this.minAmount = "";
      this.maxAmount = "";
      this.filterByAmount();
    }
  }

  resetStatusFilters() {
    if(this.order_status) {
      this.order_status = "";
      this.filterByStatus();
    }
  }

  onChangeOrderTypeFilter(value: string) {
    this.selectedOrderType = value;
    this.params.order_type = value;
    this.getPage(1, true, this.params)
  }

  goBackToListing() {
    this.selectedOrder = null;
  }

  onViewOrder(order: any) {
    this.loaderService.startLoading();
    this.orderService.get(order.uuid).subscribe((order: any) => {
      this.loaderService.stopLoading();
      this.selectedOrder = order;
    }, err => {
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      this.loaderService.stopLoading();
    })
  }

  onViewOrderByUUid(uuid) {
    this.loaderService.startLoading();
    this.selectedOrder = null;
    this.orderService.get(uuid).subscribe((order: any) => {
      this.loaderService.stopLoading();
      this.selectedOrder = order;
    }, err => {
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      this.loaderService.stopLoading();
    })
  }

  public getPage(page: number, loading: boolean = true, additionalParams: any = null) {

    if (loading) {
      this.loaderService.startLoading();
      this.loading = true; // to show loading text in table
    }

    let params: any = {
      page: page,
      limit: this.paginator.itemsPerPage
    }

    if (this.searchText && this.searchText.length >= 3) {
      params.q = this.searchText;
    }

    if (additionalParams) {
      Object.assign(params, additionalParams);
    } 
    if(this.params) {
      Object.assign(params, this.params);
    }
    // else if (this.selectedOrderType){
    //   Object.assign(params, { order_type: this.selectedOrderType });
    // }
    // Object.assign(params, additionalParams, this.params);

    if (params.from_date) {
      this.fromDate = parseDate(params.from_date);
    }

    if (params.to_date) {
      this.toDate = parseDate(params.to_date);
    }

    if (this.fromDate)
      params.from_date = this.fromDate;

    if (this.toDate)
      params.to_date = this.toDate;

    

    if (params.from_due_date) {
      this.fromDueDate = parseDate(params.from_due_date);
    }

    if (params.to_due_date) {
      this.toDueDate = parseDate(params.to_due_date);
    }

    if (this.fromDueDate)
      params.from_due_date = this.fromDueDate;

    if (this.toDueDate)
      params.to_due_date = this.toDueDate;


    this.getData(params).subscribe(
      (r) => {
        if (r.meta) {
          this.paginator.totalItems = r.meta.total;
          this.paginator.itemsPerPage = r.meta.per_page;
          this.paginator.currentPage = r.meta.current_page;
          this.paginator.from = r.meta.from;
          this.paginator.to = r.meta.to;
          this.orders = r.data;
        }

        this.loaderService.stopLoading();
        this.loading = false;
        setTimeout(() => {
          $('#tab-links-select[nice-select]').niceSelect('update');
        }, 100);
      }, (err) => {
        this.loading = false;
        this.loaderService.stopLoading()
      }
    )
  }

  getData(params): Observable<any> {
    let url = OrderApi.endPoint;

    if (url.indexOf('?') == -1)
      url += ('?' + queryString(params));
    else
      url += ('&' + queryString(params));

    return this.httpClient.get(`${url}`).pipe(
      catchError((err: any) => {
        this.loaderService.stopLoading()
        return throwError(err);
      })
    )
  }

  fetchOrders(sortColumn?: string, sortDirection?: string) {
    this.params.order_by = sortColumn;
    this.params.direction = sortDirection;
    this.getPage(1, true, this.params)
  }

  updateOrderStatuses(obj: any) {
    this.loaderService.startLoading();
    this.orderService.action({ 'do': obj.action, 'uuid': obj.uuid }).subscribe(data => {
      Swal.fire('', i18n.order.order_status_updated, 'success');
      this.params.order_type = this.selectedOrderType;
      this.getPage(1, false, this.params)
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  orderAction(obj: any) {
    switch (obj.action) {
      case "accept":
        this.markAsAccept(obj);
        break;
      case "cancel":
        this.markAsCancel(obj.uuid);
        break;
      case "rejected":
        this.markAsRejectedWithReason(obj);
        break;
      case "request_declined":
        this.markAsRejectedWithReason(obj);
        break;
      case "declined":
        this.markAsRejectedWithReason(obj);
        break;
      case "resend_invoice":
        this.doAction(obj);
        break;
      case "delete":
        this.doAction(obj);
        break;
      case "create_logistiq":
        this.createLogistiq(obj.uuid);
        break;
      case "change_priority":
        this.scheduledAction(obj);
        break;
      case "scheduled_read":
        this.scheduledAction(obj);
        break;
      // case 'convert_to_invoice':
      //   this.convertToInvoice(obj.uuid)
      //   break;
    }
    // this.activeTab = 'all-quotes';
  }

  scheduledAction(obj: any) {
    if (obj) {
      this.orderService.action({ 'do': obj.action, 'uuid': obj.uuid }).subscribe((data: any) => {        
        this.remindOrders = data?.remind_orders;
        this.scheduleOrders = data?.schedule_orders;
        if (obj.action == 'change_priority') {
          this.params.order_type = this.selectedOrderType;        
          this.getPage(1, false, this.params)
        }        
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }


  createLogistiq(selected: any) {
    if (selected.length) {
      this.loaderService.startLoading();
      this.orderService.action({ 'do': ORDER_ACTIONS.CREATE_LOGISTIQ, 'uuid': selected }).subscribe((data: any) => {
        Swal.fire('', data?.message, 'success');
        this.params.order_type = this.selectedOrderType;
        this.getPage(1, false, this.params)
      }, err => {
        this.loaderService.stopLoading();
        let error = err.error.error ? err.error.error : i18n.getError(err);
        Swal.fire(i18n.alert.error, error, 'error');
      });
    }
  }

  doAction(obj: any) {
    if (obj) {
      this.loaderService.startLoading();
      this.orderService.action({ 'do': obj.action, 'uuid': obj.uuid }).subscribe((data: any) => {        
        Swal.fire('', data?.message, 'success');
        this.params.order_type = this.selectedOrderType;        
        this.getPage(1, false, this.params)        
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsAccept(obj: any) {
    if (obj) {
      this.loaderService.startLoading();
      this.orderService.action({ 'do': ORDER_ACTIONS.MARK_AS_ACCEPT, 'uuid': obj.uuid }).subscribe(data => {
        Swal.fire('', i18n.order.marked_as_accepted, 'success');
        this.params.order_type = this.selectedOrderType;
        this.getPage(1, false, this.params)
        if (obj?.from == 'detail') {
          this.onViewOrderByUUid(obj.uuid);
        }
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsCancel(selected: any) {
    if (selected.length) {
      this.loaderService.startLoading();
      this.orderService.action({ 'do': ORDER_ACTIONS.MARK_AS_CANCELED, 'uuid': selected }).subscribe(data => {
        Swal.fire('', i18n.order.marked_as_canceled, 'success');
        this.params.order_type = this.selectedOrderType;
        this.getPage(1, false, this.params)
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsRejectedWithReason(obj: any) {
    if (obj) {
      this.loaderService.startLoading();
      this.orderService.action({ 'do': obj.action, 'uuid': obj.uuid, 'reason': obj.rejected_reason }).subscribe(data => {
        Swal.fire('', i18n.order.marked_as_declined, 'success');
        this.params.order_type = this.selectedOrderType;
        this.getPage(1, false, this.params)
        if (obj?.from == 'detail') {
          this.onViewOrderByUUid(obj.uuid);
        }
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  exportXls() {
    (window as any).open(`${environment.baseUrl}/orders/download?from=${this.fromDate}&to=${this.toDate}&status=${this.order_status}`, '_self', 'location=yes');
  }

  toggleSelectMenu() {
    $('#multiselect').removeClass('d-none');
  }

  @HostListener('document:click', ['$event'])
  DocumentClick(event: Event) {
    if (!this.elem.nativeElement.contains(event.target)){
      $('#multiselect').addClass('d-none');
    }
  }

  // orderAction(selected: Array<string>) {
  //   if (selected.length) {
  //     Swal.fire({
  //       title: i18n.are_you_sure,
  //       text: i18n.quote.you_want_to_delete_quotation,
  //       icon: 'info',
  //       showCloseButton: true,
  //       showCancelButton: true,
  //       focusConfirm: false,
  //       confirmButtonText:
  //         i18n.yes,
  //       cancelButtonText:
  //         i18n.no_cancel_it
  //     }).then(result => {
  //       if (result.value) {
  //         this.loaderService.startLoading();

  //         this.orderService.action({ 'do': ORDER_ACTIONS.MARK_AS_APPROVE, 'ids': selected }).subscribe(data => {
  //           this.loaderService.stopLoading();
  //           this.getPage(1, false, { order_type: this.selectedOrderType })
  //           Swal.fire(i18n.deleted, selected.length == 1 ? i18n.quote.quote_deleted : i18n.quote.quotes_deleted, 'success');

  //         }, err => {
  //           this.loaderService.stopLoading();
  //           Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
  //         });
  //       }
  //     });
  //   }
  // }
}
